(function ($) {
    $(document).ready(function() {
        if (!navigator.share) {
            $('.instagram-share').closest('li').remove();
        }
    })

    function socialWindow(url) {
        const left = (screen.width - 570) / 2;
        const top = (screen.height - 570) / 2;
        const params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
        window.open(url, "NewWindow", params);
    }

    $(".social-share.facebook").on("click", function () {
        const pageUrl = encodeURIComponent(document.URL);
        const url = "https://www.facebook.com/sharer.php?u=" + pageUrl;
        socialWindow(url);
    });

    $('.instagram-share').on('click', function () {
        const url = $(this).data('url');
        const title = $(this).data('title');

        if (navigator.share) {
            navigator.share({
                title: title,
                url: url
            }).then(() => {
                console.log('Thanks for sharing!');
            })
                .catch(console.error);
        } else {
            // fallback
        }
    });

    $(".social-share.pinterest").on("click", function () {
        const pageUrl = $(this).data('url');
        const description = $(this).data('description');
        const imageUrl = $(this).data('image');

        const url = `https://www.pinterest.com/pin/create/button/?url=${pageUrl}&media=${imageUrl}&description=${description}`;
        socialWindow(url);
    });
})(jQuery);